import { I18nConfig, TranslationChunksConfig, TranslationResources } from '@spartacus/core';

const customUser = {
  customCallback: {
    dialog: {
      title: 'Заказать обратный звонок',
      title_error: 'Произошла ошибка',
      title_success: 'Форма отправлена',
    },
    form: {
      text: 'Введите свой номер телефона и Вам поступит бесплатный звонок от нашего контактного центра.',
      text_error:
        'Произошла ошибка. Попробуйте позже или позвоните <a href="tel:88003337719" class="phone-number">8-800-333-77-19</a>',
      text_success: 'Заявка на звонок создана',
      button: 'Жду звонка',
      button_error: 'Ок',
      button_success: 'Ок',
    },
  },
  customReportIssue: {
    dialog: {
      title: 'Помогите нам сделать магазин лучше',
      title_error: 'Произошла ошибка',
      title_success: 'Форма отправлена',
    },
    form: {
      text: 'Опишите проблему с которой Вы столкнулись на нашем сайте, мы ее обязательно исправим.',
      text_success: 'Ваш отзыв принят. Спасибо.',
      text_error:
        'Произошла ошибка. Попробуйте позже или позвоните <a href="tel:88003337719" class="phone-number">8-800-333-77-19</a>',
      button: 'Отправить',
      button_error: 'Ок',
      button_success: 'Ок',
    },
  },
  customLoginForm: {
    code: {
      subtitle: 'Мы отправили код подтверждения на номер {{phone}}',
    },
  },
};

const ru = {
  customUser,
};

const userTranslations: TranslationResources = {
  ru,
};

const userTranslationChunksConfig: TranslationChunksConfig = {
  customUser: ['customCallback', 'customReportIssue', 'customLoginForm'],
};

export const userI18nConfig: I18nConfig = {
  i18n: {
    resources: userTranslations,
    chunks: userTranslationChunksConfig,
  },
};
